"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mapper_1 = __importDefault(require("./mapper"));
const handy_redis_1 = require("handy-redis");
class RedisMapper extends mapper_1.default {
    constructor(name, schema) {
        super(name, schema);
        this.redis = (0, handy_redis_1.createHandyClient)(`redis://${process.env.REDIS_URL}`);
    }
    getName(ID) {
        return this.name + '/' + ID;
    }
    async load(ID) {
        console.log(`loading from redis with ID ${ID}`);
        const response = await this.redis.get(this.getName(ID));
        if (!response)
            throw new Error('Not found');
        console.log(`successfully loaded from redis with ID ${ID}`);
        const obj = JSON.parse(response);
        return this.newModel(obj, 'loaded');
    }
    async loadBatch(IDs) {
        console.log('loading from redis with IDs', IDs);
        const response = await this.redis.mget(...IDs.map(ID => this.getName(ID)));
        console.log('Load Batch response ::', response);
        if (!response)
            return [];
        console.log('successfully loaded from redis with IDs', IDs);
        return response
            .filter(i => !!i)
            .map((i) => {
            if (typeof i === 'string')
                i = JSON.parse(i);
            return this.newModel(i, 'loaded');
        });
    }
    async query(query) {
        console.log('Query query: ', query);
        console.log('Name: ', this.name);
        const keys = await this.redis.keys(this.name + '/' + query);
        console.log('Query keys:: ', keys);
        const models = [];
        await Promise.all(keys.map(async (key) => {
            const data = await this.redis.get(key);
            console.log('Query response ::', data);
            models.push(this.newModel(JSON.parse(data), 'loaded'));
        }));
        return models;
    }
    async commit(model) {
        if (!model.created)
            model.created = new Date().getTime();
        model.updated = new Date().getTime();
        console.log(`committing to redis with ID ${model.ID}`);
        const ttl = model.ttl;
        const expiry = ttl ? Math.floor((ttl - Date.now()) / 1000) : undefined;
        if (expiry) {
            await this.redis.set(this.getName(model.ID), JSON.stringify(model.toDB()), [
                'EX',
                expiry,
            ]);
        }
        else {
            await this.redis.set(this.getName(model.ID), JSON.stringify(model.toDB()));
        }
        console.log(`successfully committed to redis with ID ${model.ID}`);
        return;
    }
    async delete(model) {
        console.log(`deleting from redis with ID ${model.ID}`);
        await this.redis.del(this.getName(model.ID));
        console.log(`successfully deleted from redis with ID ${model.ID}`);
        return;
    }
}
exports.default = RedisMapper;
